import cookie from "./_cookie";
import {InitSlider} from "./slider";

const recent = document.querySelector('.js-get-recently');
const recentViewed = document.querySelector('.js-get-recently-viewed');

if (recent) {

    if(cookie.get('recently-viewed') !== null) {
        async function fetchProducts() {
            const currentProducts = cookie.get('recently-viewed').split(',');

            for (const currentProduct of currentProducts) {
                try {
                    const response = await fetch(`/products/${currentProduct}?section_id=product-block-by-id`);
                    const html = await response.text();

                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, 'text/html');
                    const numberOfItems = doc.querySelector('.js-product-block');

                    recent.insertAdjacentHTML('beforeend', doc.querySelector('.js-product-data').innerHTML);
                } catch (error) {
                    console.error(error);
                }
            }
            postFetchActions();

            if(currentProducts.length <= 4) {
                const slider = recentViewed.querySelector('.js-slider');
                const arrowPrev = slider.querySelector('.js-slider-arrow[data-prev]');
                const arrowNext = slider.querySelector('.js-slider-arrow[data-next]');
                arrowPrev.setAttribute('disabled', '');
                arrowNext.setAttribute('disabled', '');
            }
        }
        fetchProducts();

        function postFetchActions() {
            const slider = recentViewed.querySelector('.js-slider');
            if (slider) {
                InitSlider(slider, 'no-width');
            }
        }
    } else {
        recentViewed.classList.add('d-none');
    }
}

export const recentProducts = (newProduct, max, days) => {

    let currentProducts = cookie.get('recently-viewed');

    if (currentProducts && currentProducts !== ''){

        const products = currentProducts.split(',');
        var index = products.indexOf(newProduct);

        if (index !== -1) {
            products.splice(index, 1);
        }

        products.unshift(newProduct);
        products.slice(0, 10);
        cookie.set('recently-viewed', products, 14);

    } else {
        cookie.set('recently-viewed', newProduct, 14);
    }
}